module.exports = __webpack_public_path__ + "img/dialog_image_S102P.773f91ed.png";